import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import TableContainer from '../../../components/Common/TableContainer';
import { Card, CardBody, Container } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ValeurVinalForm from './valeurVinalForm';
import { parametrageActions } from './parametrageSlice';

const ValeurVinalTable = () => {

  const { t } = useTranslation('translation');
  const { puissFis, categVH } = useSelector(state => state.data);
  const { isFetching, vvinales } = useSelector(state => state.parametrage);
  const [editingItem, setEditingItem] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(parametrageActions.listVvinale())
  }, [])


  const handleEdit = (item) => {
    setEditingItem(item);
  };

  const columns = [
    {
      Header: t('parametrage.categorieV'),
      disableFilters: true,
      filterable: false,
      accessor: (cellProps) => {
        return (
          <div>
            {categVH.find(c => c.code === cellProps.categVeh)?.description}
          </div>
        )
      }
    },
    {
      Header: t('parametrage.puissanceFiscale'),
      disableFilters: true,
      filterable: false,
      accessor: (cellProps) => {
        if(cellProps.pfMin == 0){
          return (
            <div>
              {`Pu <= ${cellProps.pfMax}`}
            </div>
          )
        }else{
          return (
            <div>
              {`${cellProps.pfMin} <= Pu < ${cellProps.pfMax}`}
            </div>
          )
        }
      }
    },
    {
      Header: "Année 1",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentYear1Di}%) / Essence (${cellProps.percentYear1Es}%) / Hybride (${cellProps.percentYear1Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Année 2",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentYear2Di}%) / Essence (${cellProps.percentYear2Es}%) / Hybride (${cellProps.percentYear2Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Année 3",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentYear3Di}%) / Essence (${cellProps.percentYear3Es}%) / Hybride (${cellProps.percentYear3Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Année 4",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentYear4Di}%) / Essence (${cellProps.percentYear4Es}%) / Hybride (${cellProps.percentYear4Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Année 5",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentYear5Di}%) / Essence (${cellProps.percentYear5Es}%) / Hybride (${cellProps.percentYear5Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Après 10 ans",
      accessor: (cellProps) => {
        return (
          <div>
            {`Diesel (${cellProps.percentAfetrYear10Di}%) / Essence (${cellProps.percentAfetrYear10Es}%) / Hybride (${cellProps.percentAfetrYear10Hy}%)`}
          </div>
        )
      },
      disableFilters: true,
      filterable: false,
    },

    {
      Header: t('action'),
      accessor: (cellProps) => {
        return (
          <React.Fragment>
            <Link className="me-3 text-primary"
              onClick={() => handleEdit(cellProps)}
            >
              <i className="mdi mdi-pencil font-size-18"></i></Link>
          </React.Fragment>
        )
      },
      disableFilters: true,
      filterable: false,
    },
  ];


  return (
    <React.Fragment>
      {isFetching ? <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="ri-loader-line spin-icon"></i>
          </div>
        </div>
      </div> :
        <>
          <ValeurVinalForm editingItem={editingItem} />

          <TableContainer
            columns={columns}
            data={vvinales}
            isPagination={false}
            isAddParamList={true}
            customPageSizeOptions={true}
            iscustomPageSize={false}
            isBordered={false}
            customPageSize={10}
            canDownloadtemp={true}
            className="table-info"
            isGlobalFilter={false}
          //handleDownloadTemp={() => downloadTemp()}
          //handleUpload={uploadData}
          />
        </>}
    </React.Fragment>
  )
}

export default ValeurVinalTable;